import React, { useContext } from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { TenantSettingsContext } from '../../../../App'
import AmbuNetLogo from '../../../../assets/images/ambunetLogo.png'
import Header from './Header'
import LeftInfoPanel from './LeftInfoPanel'
import AccessForm from './AccessForm'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const AccessRecord = () => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
      <Stack>
        <Header logo={orgSettings?.logo} />
        <Container maxWidth="xl" style={{ flex: 1 }}>
          <Paper elevation={3} sx={{ padding: '2rem', marginTop: '2rem' }}>
            <Grid container columnSpacing={8}>
              <LeftInfoPanel orgName={orgSettings?.orgName} />

              <AccessForm />
            </Grid>
          </Paper>
        </Container>

        <footer style={{ marginTop: 20 }}>
          <AppBar position="relative" sx={{ backgroundColor: '#3d5c6b' }}>
            <Stack
              direction={{ xs: 'column', lg: 'row' }}
              gap={2}
              padding={2}
              alignItems="center"
            >
              <Box component="img" width={70} height={70} src={AmbuNetLogo} />
              <Stack>
                <Typography variant="caption" color="whitesmoke">
                  This system is powered by AmbuNet&#174;. While AmbuNet&#174;
                  provides the technical platform for accessing these records,
                  it is not liable for the accuracy of the information or any
                  decisions made based on the data provided. The responsibility
                  for proper and authorised use of this system lies with the
                  user and the organisation issuing the access. For technical
                  assistance with this platform, you may contact AmbuNet support
                  at support@ambunet.co.uk. Please note that AmbuNet support
                  cannot assist with medical queries or the content of the
                  records.
                </Typography>
              </Stack>
              <Box width={100} height={{ xs: 100, lg: 0 }} />
            </Stack>
          </AppBar>
        </footer>
      </Stack>
    </GoogleReCaptchaProvider>
  )
}

export default AccessRecord
